import React, { FC } from 'react';
import { ResultsProps } from '../../../../common/FilterPanelPage/types';
import { LaGraphToolbar } from './LaGraphToolbar';

export const ResultsExcessive: FC<ResultsProps> = ({ id }) => {
  const testId = `${id}ResultsExcessive`;

  return (
    <React.Fragment>
      <LaGraphToolbar />
      <div className="resultsExcessive" data-testid={testId} data-cy={testId}>
        <div className="labelResultsExcessive">
          Graph is too large to display, please download the data instead.
        </div>
      </div>
    </React.Fragment>
  );
};
